import * as types from '../actions/types';
import LocalStorage from '../../utils/localStorage';

const initialState = {
    allDevicesModal: { isVisible: false },
};

const modals = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.ALL_DEVICES_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                allDevicesModal: { ...state.allDevicesModal, ...payload },
            };
        }
        default:
            return state;
    }
};

export default modals;
